export default __webpack_public_path__ + "static/media/createCar.402fa863.png";